import { render, staticRenderFns } from "./Compact.vue?vue&type=template&id=48efec77&scoped=true"
import script from "./Compact.vue?vue&type=script&lang=js"
export * from "./Compact.vue?vue&type=script&lang=js"
import style0 from "./Compact.vue?vue&type=style&index=0&id=48efec77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efec77",
  null
  
)

export default component.exports